import { render, staticRenderFns } from "./merits.vue?vue&type=template&id=6edc1c98&scoped=true"
import script from "./merits.vue?vue&type=script&lang=js"
export * from "./merits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edc1c98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6edc1c98')) {
      api.createRecord('6edc1c98', component.options)
    } else {
      api.reload('6edc1c98', component.options)
    }
    module.hot.accept("./merits.vue?vue&type=template&id=6edc1c98&scoped=true", function () {
      api.rerender('6edc1c98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/assessment/components/merits.vue"
export default component.exports